 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0,
 		7: 0,
 		10: 0,
 		12: 0,
 		72: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0,
 		7: 0,
 		10: 0,
 		12: 0,
 		72: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-part~0836b975","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","11":"route-account~route-signup","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitats","37":"route-help","38":"route-highlights","39":"route-home","40":"route-importBundleUsers","41":"route-login","42":"route-myAlbum","43":"route-notFound","44":"route-notifications","45":"route-partnerDonation","46":"route-passwordReset","47":"route-plans","48":"route-profile","49":"route-redeem","50":"route-reports","51":"route-schedule","52":"route-signup","53":"route-socialLogin","54":"route-softReload","55":"route-talkSchedule","56":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"fc4f5","1":"b06ac","2":"7041d","3":"179cd","4":"cbc95","5":"579b7","6":"91d8d","7":"a4cf6","8":"dd1fe","9":"5dd1d","10":"25053","11":"a562d","12":"d5a32","13":"5d055","17":"4b7ec","18":"66d7e","19":"b8444","20":"52b5f","21":"72fa8","22":"112d3","23":"c30a0","24":"c5194","25":"df63f","26":"5f7b5","27":"7199c","28":"f37de","29":"b7e2f","30":"51e4d","31":"e485d","32":"01de2","33":"91d22","34":"cb988","35":"c5b31","36":"77330","37":"19df8","38":"476ea","39":"05f1d","40":"2c834","41":"903c6","42":"78b62","43":"71ac4","44":"1f564","45":"4ab6c","46":"094af","47":"200da","48":"eb8ff","49":"bb4d6","50":"1f5e2","51":"fb820","52":"35644","53":"10613","54":"ea8c4","55":"f0b5a","56":"22f79","57":"c9f75","58":"062e9","59":"e751b","60":"0202f","61":"d4735","62":"52a7a","63":"be82c","64":"037f3","65":"b4e1f","66":"65b3c","67":"9966d","68":"58ab5","69":"0a172","70":"31b90","71":"27a74","73":"427c0","74":"b5d53","75":"4a54a","76":"4800d","77":"785c3","78":"5b6fa"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"6":1,"9":1,"12":1,"13":1,"17":1,"19":1,"23":1,"25":1,"27":1,"30":1,"31":1,"32":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"41":1,"42":1,"43":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"55":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"66":1,"67":1,"68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-part~0836b975","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","11":"route-account~route-signup","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitats","37":"route-help","38":"route-highlights","39":"route-home","40":"route-importBundleUsers","41":"route-login","42":"route-myAlbum","43":"route-notFound","44":"route-notifications","45":"route-partnerDonation","46":"route-passwordReset","47":"route-plans","48":"route-profile","49":"route-redeem","50":"route-reports","51":"route-schedule","52":"route-signup","53":"route-socialLogin","54":"route-softReload","55":"route-talkSchedule","56":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"1d267","3":"31d6c","4":"31d6c","5":"31d6c","6":"18e4e","7":"31d6c","8":"31d6c","9":"b7595","10":"31d6c","11":"31d6c","12":"17df8","13":"91d99","17":"2071a","18":"31d6c","19":"25649","20":"31d6c","21":"31d6c","22":"31d6c","23":"60af3","24":"31d6c","25":"b36ec","26":"31d6c","27":"95288","28":"31d6c","29":"31d6c","30":"6c96c","31":"5f87a","32":"7990d","33":"31d6c","34":"362de","35":"4bf3a","36":"b6ffc","37":"3a1a1","38":"c5025","39":"2fde0","40":"31d6c","41":"1b2e4","42":"a29e2","43":"0e780","44":"31d6c","45":"1320c","46":"5255f","47":"cfcea","48":"8c877","49":"a3247","50":"576ae","51":"1eb2a","52":"3a45d","53":"31d6c","54":"31d6c","55":"ba6f8","56":"31d6c","57":"440f4","58":"1e8d3","59":"c51fe","60":"f177c","61":"1fa4d","62":"b2ca4","63":"31d6c","64":"c75d8","65":"31d6c","66":"65381","67":"91a66","68":"756f3","69":"31d6c","70":"31d6c","71":"31d6c","73":"31d6c","74":"31d6c","75":"31d6c","76":"31d6c","77":"31d6c","78":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
